package com.ustadmobile.core.db.dao.xapi

import com.ustadmobile.lib.db.entities.xapi.StateDeleteCommand

public actual abstract class StateDeleteCommandDao {
  public actual abstract suspend fun insertAsync(deleteCommand: StateDeleteCommand)
}
